// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Calendar = function Calendar(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M2.514 10.968h4.383v2.143H2.514zM9.263 10.968h4.383v2.143H9.263zM2.514 6.641h4.383v2.143H2.514zM9.263 6.641h4.383v2.143H9.263z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.23 2.554h-.872v-1.3h-2.32v1.3H5.223v-1.3H2.9v1.3H1.77a.919.919 0 00-.919.919v10.355a.919.919 0 00.919.918h12.46a.919.919 0 00.919-.918V3.473a.919.919 0 00-.919-.919zm0 11.436H1.77a.162.162 0 01-.162-.162V5.179h12.784v8.65a.162.162 0 01-.162.161z"
    }))
  );
};

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Calendar.js
// module id = 986
// module chunks = 0